import Typography from '@mui/material/Typography';
import React from 'react';

import { EmphasisColorMap } from './typography.const';
import { TypographyProps } from './typography.types';

/**
 * @deprecated Use `Heading` from `common/src/components/TypographyV2` (e.g. `<Heading size="small">`).
 */
export const H4: React.FC<TypographyProps> = ({ className, emphasis = 'high', ...props }) => {
  return (
    <Typography variant="h4" className={className} color={EmphasisColorMap[emphasis]} {...props} />
  );
};
